import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { CustomerBillService, CustomerBillData, PrForBill, CreditNote, CustomerBill, CFDI, BillFile, CustomerBillId, Incomed, BillingJsonVersion4, BucketFile, /* Complement */ } from '../../services/customer-bill.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { ProductionOrderService, ProductionOrderData } from '../../services/production-order.service';
import { RemissionService } from '../../services/remission.service';
import { CatalogsSettingsService, Folios, PayrollId } from '../../services/catalogs-settings.service';
import { ProductVntaService, PrVntaData } from '../../services/product-vnta.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { CompanyData } from '../../services/company.service';
import { Table, Cells, RightCell, Globals } from '../../globals';
import { IncomedBill, IncomeId, IncomeService, IncomeData, IncomeBill, FolioLog } from '../../services/income.service';
import { Upload } from '../../services/upload/upload';
import { BankData } from '../../services/bank.service';
import { environment } from '../../../environments/environment';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { AuthService } from '../../services/auth.service';

interface IncomeTable extends BillFile {
  id: string, folio: string, bill: IncomeBill, bills:IncomeBill[], infoBills: InfoBill[], amount: number,
  date: string, payMethod: IncomeData['statusObjects'][IncomeId['payMethod']]['index'], payMethodText: string, bank: string, currency: CustomerBillData['currencySelect'][CustomerBill['currency']]['code'], status: string, uuid: string,
  _stampedByMedicosproBackendServer: boolean
}
interface InfoBill{
  id: string, uuid: string, folio: string, currency: string, totals: any, payMethod: string, bias: number, amount: number, extraAmount: number, residue: number, incomeds: Incomed[], creditNotes: CreditNote[], 
}

@Component({
  selector: 'app-display-customer-bill',
  templateUrl: './display-customer-bill.component.html',
  styleUrls: ['./display-customer-bill.component.css']
})
export class DisplayCustomerBillComponent implements OnInit, OnDestroy {
  id: string;
  customerBill: CustomerBillId & { [key: string]: any };

  customerId: string;
  fiscalDataId: string;
  customerName: string = '';
  fiscalData:any = {};

  form: FormGroup;
  cfdiForm: FormGroup;
  folio: number;
  
  settings: PayrollId;
  pickadateParams = Utils.pickadateParams();

  subs: Subscription[] = [];
  incomeSubs: Subscription[] = [];

  
  constructor(
    private service: CustomerBillService,
    private firestoreService: FirestoreService,
    private incomeService: IncomeService,
    private incomeData: IncomeData,
    private bankData: BankData,
    private customerService: CustomerSupplierService,
		private fiscalDataService: FiscalDataService,
    private data: CustomerBillData,
    private productionOrderService: ProductionOrderService,
    private remissionService: RemissionService,
    private settingsService: CatalogsSettingsService,
    private prVntaService: ProductVntaService,
    private prVntaData: PrVntaData,
    private authService: AuthService,
    private companyData: CompanyData,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');

    //Utils.getFile('https://interfaces.medicospro.com/facturacion/MOB1203201F5/Cfdi/Factura_A_4_Timbrado.txt').then(res => console.log(res))
  }

  ngOnInit() {
    this.createForm();
    this.createCfdiForm();
    this.subs.push(
      this.settingsService.getPayrollSettings('1').subscribe(settings => {
        this.settings = settings;
      })
    );
    this.subs.push(
      this.service.getCustomerBill(this.id).subscribe(([{companyObj, cfdi={}, productionOrderObj:[{name=''}={}]=[], employeeObj, status='key0', uuid='', /* complements=[], */ ...customerBill}]) => {
        customerBill.productionOrder = name;
        customerBill.employee = employeeObj ? `${employeeObj.name} ${employeeObj.lastName}` : '';
        this.notesMail = `A través de la presente, ${companyObj.name} le envíamos los archivo(s) generado(s) para su CFDI. Seguimos a sus órdenes para cualquier duda!`;
        this.customerBill = {
          companyImgUrl: companyObj.imageURL,
          companyName: companyObj.name,
          companyFiscalRegimen: this.companyData.fiscalRegimenSelect[companyObj.fiscalRegimen || 'key0'].code,
          companySatPrivateKey: companyObj.satPrivateKey || '',
          companyFiles: companyObj.files || [],
          companyZipCode: companyObj.postCode,
          companyRfc: companyObj.RFC,
          companyFiscalData: companyObj.socialReason,
          companyEmail: companyObj.email,
          displayCfdi: Object.keys(cfdi).reduce((acc, cur) => {
            if(cur == 'payForm'){ acc[cur] = this.data.payFormSelect[`${cfdi[cur]}`].index; acc['payFormText'] = this.data.payFormSelect[`${cfdi[cur]}`].full }
            else if(cur != 'change' && cur != 'bankDigits') acc[cur] =  this.data[`${cur}Select`][`${cfdi[cur]}`].full;
            else acc[cur] = cfdi[cur];
            return acc;
          }, {}),
          cfdi,
          status,
          uuid,
          associatedRelationType: '',
          associatedBillFolio: '',
          associatedBillDate: '',
          associatedBillAmount: '',
          associatedBillUuid: '',
          /* complements, */
          ...customerBill
        };
        //console.log(this.customerBill);
        this.customerId = customerBill.customerObj.id;
        this.customerName = customerBill.customerObj.name;
        this.fiscalDataId = customerBill.fiscalDataObj.id;
        //console.log(customerBill)
        //console.log(customerBill.incomeds)
        this.form.patchValue(customerBill);
        this.cfdiForm.patchValue(this.customerBill.displayCfdi);
        this.prForBills = customerBill.prForBills.map(({remissionId, productRef, ...pr}) => {
          pr.product = Utils.cleanString(pr.product, this.data.PRODUCT_ALLOWED_CHARS);
          pr.notes = Utils.cleanString(pr.notes, this.data.PRODUCT_ALLOWED_CHARS);
          if(!remissionId) return {remissionFolio: 'N.A', ...pr};
          let sub = this.remissionService.getRemission(remissionId).subscribe(([remission]) => {
            sub.unsubscribe();
            pr.remissionFolio = `${remission.folio}`;
          });
          return pr;
        });
        this.creditNotes = customerBill.creditNotes.map(({status='key0', folio, ...c}) => ({
          status,
          folio: this.data.ncFolio(folio, customerBill.folio),
          ...c
        }) );

        this.cleanInSubs();
        this.incomes = [];
        customerBill.incomeds.map(({incomeRef}, i, a) => {
          this.incomeSubs[i] = this.incomeService.getIncome(incomeRef.id).subscribe(([income]: IncomeId[]) => {
            let {id, bills, folio='', date, payMethod='001', amount, bankObj: {accountNumber, bankName, currency}, status='key0', uuid='', Timbrado_xml, Timbrado_pdf, Cancelado_xml, Cancelado_pdf} = income;
            let bill = bills.find(({customerBillId: cId}) => cId == this.id);
            
            this.incomes[i] = {
              id, bill, bills, infoBills: [], date, status, uuid, folio, amount,
              payMethod: this.incomeData.statusObjects[payMethod].index, payMethodText: this.incomeData.statusObjects[payMethod].name,
              bank: `${accountNumber}, ${bankName}`,
              currency: this.bankData.currencies[currency].short,
              Timbrado_xml, Timbrado_pdf, Cancelado_xml, Cancelado_pdf,
              _stampedByMedicosproBackendServer: income._stampedByMedicosproBackendServer || false,
            };

            if(i == a.length-1) this.defineRowsIncome();
          });
        });
        //window['incomes'] = this.incomes;
        /* this.complements = complements.map(c => new Complement(0,c)); this.defineRowsComplement(); */

        /////Temporal
        /* let {companyRfc, folio: f} = this.customerBill;
        let s1 = this.tempSearch(), s2 = this.tempSearch();
        if(status != 'key0') s1.start(0, 0, this.customerBill, {onlyFiles: ['pdf', 'xml']});
        if(status > 'key90') s2.start(0, 1, this.customerBill, {onlyFiles: ['pdf', 'xml']});
        this.creditNotes.map(({status, folio, ...cn}, cni) => {
          let s1 = this.tempSearch(), s2 = this.tempSearch();
          if(status != 'key0') s1.start(0, 2, {companyRfc, folio, status}, {cni, onlyFiles: ['pdf', 'xml']});
          if(status > 'key90') s2.start(0, 3, {companyRfc, folio, status}, {cni, onlyFiles: ['pdf', 'xml']});
        })
        this.complements.map(({status, folio, ...cn}, cni) => {
          let s1 = this.tempSearch(), s2 = this.tempSearch();
          if(status != 'key0') s1.start(0, 4, {companyRfc, folio, status}, {cni, onlyFiles: ['pdf', 'xml']});
          if(status > 'key90') s2.start(0, 5, {companyRfc, folio, status}, {cni, onlyFiles: ['pdf', 'xml']});
        }) */
        /////Temporal
        this.form.get('associatedRelationTypeString').patchValue(`${customerBill.associatedRelationType || ''}: ${this.data.associatedRelationTypes[customerBill.associatedRelationType || '']}`);
        this.customerBill.associatedRelationType = customerBill.associatedRelationType || '';
        if(customerBill.associatedBillId) this.firestoreService.docWithId<CustomerBillId>(`${this.service.collection}/${customerBill.associatedBillId}`).then(bill => {
          if(bill == null) return;
          this.customerBill.associatedBillFolio = bill.folio;
          this.customerBill.associatedBillDate = bill.date;
          this.customerBill.associatedBillAmount = bill.totals.total;
          this.customerBill.associatedBillUuid = bill.uuid || '';
          this.form.get('selectedBillString').patchValue(`Folio: ${bill.folio}, Fecha: ${bill.date}, Importe: ${Utils.money(bill.totals.total)}, UUID: ${bill.uuid || ''}`);
        });
      })
    )

  }
	ngOnDestroy() {
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
    this.cleanInSubs();
  }
  cleanInSubs(){
    this.incomeSubs.map(sub => { if(sub) sub.unsubscribe(); })
    this.incomeSubs = [];
  }

	onEdit() {
    //if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.service.windowReplace('edit', `${this.id}/${this.fiscalDataId}/${this.customerId}`);
    localStorage.returnToDisplay = 'true';
	}

  createForm(){
    this.form = this.fb.group({
      folio: '',
      date: '',
      receptionDate: '',
      payDate: '',
      notes: '',
      productionOrder: '',
      employee: '',
      associatedRelationTypeString: '',
      selectedBillString: '',
    });
  }
  createCfdiForm(){
    this.cfdiForm = this.fb.group({
      payFormText: '',//payForm: '',
      payMethod: '',
      payConditions: '',
      cfdiUsage: '',
      currency: '',
      change: 1,
      bankDigits: ''
    })
  }

  money = Utils.money;
  /* money(value){
    return Utils.money(value);
  } */

  //////////////////////////////////////////////////////////////////////////////////////////////PR_FOR_BILL
  prForBills: PrForBill[] = [];
  get retIsr(): number { return this.prForBills.reduce((acc,{retIsr}) => acc + retIsr, 0) }
  get retIva(): number { return this.prForBills.reduce((acc,{retIva}) => acc + retIva, 0) }
  get subtotal(): number { return this.prForBills.reduce((acc,{subtotal}) => acc + subtotal, 0) }
  get iva(): number { return this.prForBills.reduce((acc,{iva}) => acc + iva, 0) }
  get total(): number { return (+this.subtotal.toFixed(2)) + (+this.iva.toFixed(2)) /* this.prForBills.reduce((acc,{total}) => acc + total , 0)*/ }
  get amountNoDisc(): number { return +this.prForBills.reduce((acc,{amountNoDisc}) => acc + amountNoDisc, 0).toFixed(2) }
  get totals(): any[] { return [
    {name: 'Subtotal sin descuento', key: 'amountNoDisc', get: +this.amountNoDisc.toFixed(2) },
    {name: 'Retención ISR', key: 'retIsr', get: +this.retIsr.toFixed(2) },
    {name: 'Retención IVA', key: 'retIva', get: +this.retIva.toFixed(2) },
    {name: 'Subtotal', key: 'subtotal', get: +this.subtotal.toFixed(2) },
    {name: 'IVA', key: 'iva', get: +this.iva.toFixed(2) },
    {name: 'Total', key: 'total', get: +this.total.toFixed(2) },
  ] }
  //////////////////////////////////////////////////////////////////////////////////////////////PR_FOR_BILL

  //////////////////////////////////////////////////////////////////////////////////////////////CREDIT_NOTE
  creditNotes: CreditNote[] = [];
  get creditNotesTotal(): number { return this.creditNotes.reduce((acc,{total}) => acc + total, 0) }
  //////////////////////////////////////////////////////////////////////////////////////////////CREDIT_NOTE

  /* //////////////////////////////////////////////////////////////////////////////////////////////COMPLEMENT
  complements: Complement[] = [];
  complementsTable: Table = {
    parent: this,
    caption: 'Complementos de pago',
    columns1: Cells(['Folio','Fecha','Método pago','Moneda','Cambio','No. Par.','IVA','Subtotal','IVA total','Total']),
    rows1: []
  }
  defineRowsComplement(){
    this.complementsTable.rows1 = this.complements.map((c: Complement) => Cells([
      c.folio, c.date, this.data.payMethodSelect[c.payMethod].full, this.data.currencySelect[c.currency].code,
      c.change, c.bias, RightCell(`${c.iva}%`), RightCell(Utils.money(c.subtotal)), RightCell(Utils.money(c.ivatotal)), RightCell(Utils.money(c.total)),
    ]) )
  }
  //////////////////////////////////////////////////////////////////////////////////////////////COMPLEMENT */

  //////////////////////////////////////////////////////////////////////////////////////////////INCOME 1
  
  incomes: IncomeTable[] = [];
  incomesTable: Table = {
    parent: this,
    caption: 'Ingresos asociados',
    columns1: Cells(['Folio', 'Fecha', 'Cuenta', 'Método pago', 'Cantidad', 'Compensación', 'Moneda', 'UUID', 'Status', 'Archivos']),
    rows1: []
  }
  defineRowsIncome(){
    this.incomesTable.rows1 = this.incomes.map(inc => Cells([ inc.folio, inc.date, inc.bank, inc.payMethodText, `${inc.bill.amount}`, `${inc.bill.extraAmount || 0}`, inc.currency, inc.uuid ]) )
  }

  onNewIncome(){
    localStorage.billReturnIncome = this.id;
    this.service.windowReplace('incomeAdd', `${this.customerBill.fiscalDataObj.id}/${this.customerBill.customerObj.id}`);
  }
  onViewIncome(id: string){
    localStorage.billReturnIncome = this.id;
    this.service.windowReplace('incomeView', id)
  }
  //////////////////////////////////////////////////////////////////////////////////////////////INCOME 2



  onPdf(isReceipt=false){
    if(isReceipt){
      window['sendFacturaReciboToPhp'](this.pdfJson);
    }else{
      //console.log(JSON.parse(this.pdfJson))
      window['sendFacturaToPhp']();
      //this.search.start(120, 0, this.customerBill);
    }
  }
  async onCancelPdfPre(){
    if(this.motivoCancelacion == '00') return toast('Debe de seleccionar un motivo.', 2000);
    if(this.motivoCancelacion == '01'){
      let bills = await this.firestoreService.colWithIds<CustomerBillId>(Globals.CUSTOMER_BILL_COLLECTION);
      //console.log(this.customerBill);
      //console.log(bills.filter(bill => bill.uuid && bill.customerRef.id == this.customerBill.customerObj.id));
      this.otherUuids = bills.filter(bill => bill.uuid && bill.customerRef.id == this.customerBill.customerObj.id).map(bill => bill.uuid).sort();
      this.otherUuid = this.otherUuids[0] || '';
      //console.log(this.otherUuids);
      this.openModalCancel();
    }else this.onCancelPdf();
  }
  onCancelPdf(closeModal: boolean = false){
    if(closeModal) this.closeModalCancel();
    //if(1) return console.log(this.cancelPdfJson);
    //window['sendCancelacionFacturaToPhp']();
    //this.search.start(120, 1, this.customerBill);
    this.sendBillForStamping({ cancel: true });
  }

  get pdfJson(){
    let SOURCE: number;
    switch(environment.cloudFirestore.projectId){
      case 'proy-pruebas': SOURCE = 0; break;
      case 'sireilusa': SOURCE = 1; break;
      case 'sire-web': SOURCE = 2; break;
    }
    //window['testTmp'] = +this.prForBills.reduce((acc, cur) => acc + ((cur.pricePerUnit*cur.quantity)*(cur.discountPct/100)|| 0), 0);
    let {totals} = this;
    let oldTotals = [...totals.slice(1),totals[0]];
    return this.customerBill ? JSON.stringify({
      SOURCE,
      billId: this.id,
      customerName: this.customerName,
      customerRfc: this.customerBill.fiscalDataObj.rfc,
      customerFiscalData: this.customerBill.fiscalDataObj.businessName,
      customerPostalCode: this.customerBill.fiscalDataObj.postCode || '',
      customerFiscalRegimen: this.companyData.fiscalRegimenSelect[this.customerBill.fiscalDataObj.fiscalRegimen || 'key0'].full,
      productionOrder: this.customerBill.productionOrder,

      date: this.customerBill.date,
      folio: this.customerBill.folio,
      receptionDate: this.customerBill.receptionDate,
      payDate: this.customerBill.payDate,
      prForBills: this.prForBills.map(pr => ({...pr, discountAmount: +((+(pr.pricePerUnit*pr.quantity).toFixed(2))*(pr.discountPct/100)).toFixed(2)})),
      creditNotes: this.creditNotes,
      incomeds: this.incomesTable.rows1.map(row => ({folio: row[0], uuid: row[7], amount: row[4], extraAmount: row[5]})),

      discountTotal: +this.prForBills.reduce((acc, cur) => acc + (+((cur.pricePerUnit*cur.quantity).toFixed(2))*(cur.discountPct/100)|| 0), 0).toFixed(2),
      totals: oldTotals,

      cfdi: this.customerBill.displayCfdi,

      companyImgUrl: this.customerBill.companyImgUrl,
      companyName: this.customerBill.companyName,
      companyFiscalRegimen: this.customerBill.companyFiscalRegimen, 
      companyFiles: this.customerBill.companyFiles,
      companyZipCode: this.customerBill.companyZipCode,
      companyRfc: this.customerBill.companyRfc,
      companyFiscalData: this.customerBill.companyFiscalData,
      companySatPrivateKey: this.customerBill.companySatPrivateKey,

      associatedRelationType: this.customerBill.associatedRelationType,
      associatedBillFolio: this.customerBill.associatedBillFolio,
      associatedBillDate: this.customerBill.associatedBillDate,
      associatedBillAmount: this.customerBill.associatedBillAmount,
      associatedBillUuid: this.customerBill.associatedBillUuid,

      type: 'I'

    }) : '';
  }
  get cancelPdfJson(){
    let SOURCE: number;
    switch(environment.cloudFirestore.projectId){
      case 'proy-pruebas': SOURCE = 0; break;
      case 'sireilusa': SOURCE = 1; break;
      case 'sire-web': SOURCE = 2; break;
    }
    return this.customerBill ? JSON.stringify({
      SOURCE,
      billId: this.id,
      companyRfc: this.customerBill.companyRfc,
      customerRfc: this.customerBill.fiscalDataObj.rfc,
      companySatPrivateKey: this.customerBill.companySatPrivateKey,
      uuid: this.customerBill.uuid,
      folio: this.customerBill.folio,
      total: this.customerBill.totals.total,
      companyImgUrl: this.customerBill.companyImgUrl,
      motivoCancelacion: this.motivoCancelacion,
      otherUuid: this.otherUuid || '',
    }) : '';
  }
  emailJson: string = '';
  ncPdfJson: string = '';
  comPdfJson: string = '';

  modalActionsMail = new EventEmitter<string|MaterializeAction>();
  modalParamsMail = [{dismissible: true}];
  xmlMail: string; pdfMail: string; notesMail: string;
  customerEmail: string = '';
  subjectMail: string = '';
  openModalMail(xml, pdf='', subject: string) {
    this.xmlMail = xml; this.pdfMail = pdf;
    this.subjectMail = subject || '';
    this.customerEmail = (!this.subjectMail.includes('complemento') ? this.customerBill.fiscalDataObj.email : this.customerBill.fiscalDataObj.email2) || '';
    this.modalActionsMail.emit({ action: 'modal', params: ['open'] });
  }
  closeModalMail() { this.modalActionsMail.emit({ action: 'modal', params: ['close'] }); }
  get mailValid(){ return this.customerBill && this.customerBill.companyEmail && this.customerEmail }
  sendEmail(){
    this.emailJson = JSON.stringify({
      xml: this.xmlMail, pdf: this.pdfMail,
      subject: this.subjectMail,
      date: this.customerBill.date,
      companyEmail: this.customerBill.companyEmail,
      customerEmail: this.customerEmail,
      notes: this.notesMail
    });
    window['sendFacturaToEmail'](this.emailJson);
  }

  ncSearch(index: number){
    let cn: CreditNote = this.creditNotes[index];
    //if(cn.status != 'key0') return toast('Esta función no está lista para nota de crédito.', 3000);
    let {companyRfc} = this.customerBill;
    let {folio, status, uuid} = cn;
    this.ncPdfJson = JSON.stringify({
      ...JSON.parse(this.pdfJson),
      uuid,
      uuidFac: this.customerBill.uuid,
      type: 'E',
      creditNoteFolio: folio,
      creditNoteRelation: this.data.cnRelations[cn.cfdiRelation || 'key0'].index,
      creditNoteTotal: cn.total,
      creditNoteIndex: index,
    });
    if(status == 'key0') window['sendNotaCreditoToPhp'](this.ncPdfJson);
    else window['sendNotaCreditoCancelToPhp'](this.ncPdfJson);
    this.search.start(120, status == 'key0' ? 2 : 3, {companyRfc, folio, status}, {cni: index} );
  }
  async incSearch(index: number){
    console.log(`Timbrando income.`);
    let inc: IncomeTable = this.incomes[index];
    let {folio, bills, status } = inc;
    if(!`${folio}`) return toast('No hay un folio, edite el ingreso.', 3000);
    console.log(inc)

    let billsAreKey1: boolean[] = [];
    for(let i = 0; i < bills.length; i++){
      let {customerBillId: cId, amount, extraAmount=0} = bills[i];
      let bill: CustomerBillId = await this.firestoreService.docWithId(`${Globals.CUSTOMER_BILL_COLLECTION}/${cId}`) as CustomerBillId;
      //console.log(350, bill);
      let {status='key0', uuid, folio: f, cfdi:{currency:c='key0', payMethod:p='key0'}, lastBias:{incomeId='', value=1}={} } = bill;
      billsAreKey1.push(/* status == 'key1' &&  */!!uuid);
  
      let {totals} = bill;
      let total = (+totals.subtotal.toFixed(2)) + (+totals.iva.toFixed(2));
      //console.log(`The total is ${total}, would be ${totals.total}.`, {...totals, total});
  
      let incomedBill = new IncomedBill(bill);
  
      inc.infoBills[i] = {
        id: cId, uuid, folio: `${f}`, currency: this.data.currencySelect[c].code, totals: {...totals, total},
        payMethod: this.data.payMethodSelect[p].code, amount, extraAmount, residue: incomedBill.residue,
        bias: !incomeId || incomeId == inc.id ? value : value + 1, incomeds: bill.incomeds, creditNotes: bill.creditNotes,
      }
    }
    //if(billsAreKey1.length != bills.length) return;
    //console.log(`${billsAreKey1}`)
    if(!billsAreKey1.includes(false)) await this.incSend(index);
    else toast('No todas las facturas están timbradas.', 3000);

  }
  async incSend(index: number){
    let inc: IncomeTable = this.incomes[index];
    let {companyRfc, extraFiscalObj: {rfc = '', businessName = ''} = {}} = this.customerBill;
    let {id, folio, amount, bill, bills, infoBills, currency, payMethod, status, uuid, date} = inc;
    
    ///////////////////////////// Folio change
    if(status == 'key1'){
      let settings: PayrollId = await this.firestoreService.docWithId<PayrollId>(`${Globals.CATALOGS_SETTINGS}/1`);
      let newFolio = settings.folios.income + 1;
      let userFullName = this.authService.currentUser.fullName;
      let folioLog: FolioLog = {
        lastFolio: +folio,
        newFolio,
        datetime: Utils.stringDatetime(),
        lastUuid: uuid,
        userFullName,
      };
      let income: IncomeId = await this.firestoreService.docWithId<IncomeId>(`${Globals.INCOME_COLLECTION}/${id}`);
      let folioLogs = income.folioLogs || [];
      folioLogs.push(folioLog);
      if(!confirm(`Se cambiará el folio de ${folio} a ${newFolio}.`)) return;
      await this.incomeService.updateByField({folio: newFolio, folioLogs}, id);
      settings.folios.income = newFolio;
      await this.settingsService.putPayrollSettings({folios: settings.folios}, '1');
      folio = <any> newFolio;
    }
    ///////////////////////////// Folio change

    /* if(1){
      console.log('DISPLAY_BILL.incSend()', 'Necessary data.')
      console.log(inc);
      console.log(this.customerBill)
      return;
    } */

    //console.log(888, this.incomesTable.rows1);
    //console.log(750, infoBills);
    for(let bill of infoBills){
      //let incomeRow = this.incomesTable.rows1.find(row => row[0]['name'] == folio);
      //let incomesSum = this.incomesTable.rows1.reduce((acc, cur) => acc + (cur[1]['name'] <= inc.date ? (+cur[4]['name']) : 0), 0);
      //let incomesExtraSum = this.incomesTable.rows1.reduce((acc, cur) => acc + (cur[1]['name'] <= inc.date ? (+cur[4]['name'] + +cur[5]['name']) : 0), 0);
      let incomesExtraSum = bill.incomeds.reduce((acc, cur) => acc + cur.amount + cur.extraAmount, 0);
      let incomedAmount = bill.amount;
      let incomedExtraAmount = bill.extraAmount;
      //console.log(54, bill);
      let creditNotesTotal: number = 0;
      for(let creditNote of bill.creditNotes) if(creditNote.status < 'key97') creditNotesTotal += creditNote.total;
      //console.log(bill.totals.creditNote, creditNotesTotal);
      /* console.log(
        bill.totals.total,
        creditNotesTotal,
        incomesExtraSum,
        incomedAmount,
        incomedExtraAmount,
      ) */
      /* console.log(
        +(bill.totals.total - creditNotesTotal - incomesExtraSum + incomedExtraAmount).toFixed(2),
        +(bill.totals.total - creditNotesTotal - incomesExtraSum + incomedAmount + incomedExtraAmount).toFixed(2),
        +(bill.totals.total - creditNotesTotal - incomesExtraSum).toFixed(2),
      ) */
      bill['saldoInsoluto'] = +(bill.totals.total - creditNotesTotal - incomesExtraSum + incomedExtraAmount).toFixed(2);
      bill['saldoAnterior'] = +(bill.totals.total - creditNotesTotal - incomesExtraSum + incomedAmount + incomedExtraAmount).toFixed(2);
      bill['saldoInsoluto17'] = +(bill.totals.total - creditNotesTotal - incomesExtraSum).toFixed(2);
      bill['saldoAnterior17'] = +(bill['saldoInsoluto']).toFixed(2);
      //console.log(999, bill['saldoInsoluto'], bill['saldoAnterior'], bill['saldoInsoluto17'], bill['saldoAnterior17']);
      for(let incomed of bill.incomeds) delete incomed.incomeRef;
    }
    //if(1) return;

    this.comPdfJson = JSON.stringify({
      ...JSON.parse(this.pdfJson),
      //uuid: this.customerBill.uuid,
      type: '',
      extraFiscalDataRfc: rfc,
      extraFiscalDataName: businessName,
      com: {
        currency, payMethod, bills: infoBills, folio, total: amount, uuid, date, change: 1,
        //saldoInsoluto, saldoAnterior, saldoInsoluto17, saldoAnterior17,
      },
      incomeId: id,
    });
    
    //if(1) return console.log(JSON.parse(this.comPdfJson));
    window['sendIncToPhp'](this.comPdfJson);
    this.search.start(120, status == 'key0' ? 4 : 5, {companyRfc, folio, status, uuid}, {cni: id, bills: infoBills} );
  }
  host = '35.192.124.31';
  //host = 'interfaces.medicospro.com';
  search = {
    self: this,
    counter: 0,
    interval: undefined,
    rfc: '', folio: '', status: 'key0', bills: [],
    pdf: undefined, pdfCancel: undefined,
    xml: undefined, xmlCancel: undefined,
    msg: '',
    uuid: '',
    op: undefined,//0: timbrar, 1: cancelar, 2: ncTimbre, 3: ncCancel, 4: com, 5: comCancel
    cni: -1,
    get url(){
      let host = '35.192.124.31';
      //let hots = 'interfaces.medicospro.com'
      switch (this.op){
        case 0: return `https://${this.self.host}/facturacion/${this.rfc}/Cfdi/Factura_A_${this.folio}_Timbrado`;
        case 1: return `https://${this.self.host}/facturacion/${this.rfc}/cfdiCancelado/Factura_A_${this.folio}_Cancelado`;
        case 2: return `https://${this.self.host}/facturacion/${this.rfc}/notasCredito/Factura_N_${this.folio}_Timbrado`;
        case 3: return `https://${this.self.host}/facturacion/${this.rfc}/notasCredito/Factura_N_${this.folio}_Cancelado`;
        case 4: return `https://${this.self.host}/facturacion/${this.rfc}/CfdiPagos/Factura_Pa_${this.folio}_Timbrado`;
        case 5: return `https://${this.self.host}/facturacion/${this.rfc}/CfdiPagos/Factura_Pa_${this.folio}_Timbrado`;
      };
    },
    start(n: number, op: number, {companyRfc: rfc, folio, status, uuid=<any>undefined}, {cni=<any>-1, onlyFiles=<any>false, bills=[]}={}){
      //tmp start
      return;
      //tmp end
      /* this.counter = n;
      this.op = op; this.rfc = rfc; this.folio = folio; this.status = status; this.bills = bills; this.uuid = uuid;
      this.cni = cni;
      if(n) this.interval = setInterval(this.cycle, 1000, this); */
      /* else onlyFiles ? this.endFiles(onlyFiles) : this.end(); */
    },
    cycle(THIS){
      THIS.counter--;
      if(!(THIS.counter%3)) THIS.end();
    },
    clear(){
      if(this.interval) clearInterval(this.interval);
      this.interval = undefined; this.counter = 0;
    },
    end(){
      let THIS = this;
      console.log(`Buscando: ${this.url}.txt`);
      Utils.getFile(`${this.url}.txt`).then(res => {
        if(!THIS.counter){
          THIS.clear()
          THIS.msg = 'Tiempo de espera agotado.';
          console.log('Se agotó el tiempo');
        }else if(res){
          console.log(`Contenido del txt:`);
          console.log(res);
          THIS.clear();
          let [msgs, uuids=''] = res.split('\n');
          let [msgS, msg] = msgs.split('::');
          let [uuidS, uuid] = uuids.split('::');
          let success = uuidS == 'uuid' && uuid;
          console.log(`Tuvo éxito la operación: ${success}`);
          console.log(`El uuid es: ${uuid}`)
          if(!THIS.op){
            if(success && THIS.status == 'key0') THIS.updateStatus('key1', uuid).then(r => onSuc('xml', 0));
            THIS.msg = !isNaN(+msgs[0]) ? msg : '';
            THIS.uuid = uuid;
          }else if(THIS.op == 1 || THIS.op == 3){
            if(success && THIS.status != 'key99') THIS.updateStatus('key99').then(r => onSuc('xml', 0));
            else switch(msg.split(':')[0]){
              case '201': THIS.updateStatus('key97'); break;
              case 'CANC105':
              case 'CANC106': THIS.updateStatus('key98'); break;
            }
            THIS.msg = msg//(msg || '').split(':')[0];
          }else if(THIS.op == 2){
            if(success && THIS.status == 'key0') THIS.updateStatus('key1', uuid).then(r => onSuc('xml', 0));
          }else if((THIS.op == 4 || THIS.op == 5) && success){
            let {bills, self, cni: incomeId, uuid:last="''"} = <{bills: InfoBill[], self: DisplayCustomerBillComponent, cni: any, uuid: string}>THIS;
            THIS.uuid = uuid;
            console.log(`Se cambió el uuid de ${last} a ${uuid}`);
            updateBill(0);

            function updateBill(index: number){
              let {bias, id} = bills[index];
              let lastBias = {incomeId, value: bias };
              self.service.updateByField({lastBias}, id).then(r => {
                if(bills[index+1]) updateBill(index + 1);
                else THIS.updateStatus('key1', uuid).then(r => onSuc('xml', 0));
              });
            }
          }

          let ts;
          if(msgs[0] == '1') ts = ['xml'];
          if(msgs[0] == '2') ts = ['xml', 'pdf'];

          
          //if(THIS.self.authService.currentCompanyObj.test) console.log('Es compañía testeo');
          function onSuc(t: string, i: number){
            if(success){
                console.log(`Se va a subir el ${t}`);
                let url = `${Globals.PROXY_URL}${THIS.url}.${t}`;
                console.log(`El url de búsqueda es: ${url}`)
                
                let xhr = new XMLHttpRequest();
                xhr.open("GET", url); xhr.responseType = "blob";
                xhr.onload = () => {
                  let blob = xhr.response; blob.name = `${Utils.arrayLast(url.split('/'))}`;
                  let onDone = () => !i && ts[1] ? onSuc(ts[1], 1) : null;
                  THIS.uploadFile(new Upload(<File> blob), onDone)
                };
                xhr.send();
            }//else if(success) THIS.endFiles(ts);
          }
        }
      });
    },
    /* endFiles(arr){
      arr.map(t => {
        let url = `${this.url}.${t}`, {op} = this;
        let CB = this.self.customerBill, CN = this.self.creditNotes[this.cni], CO = this.self.complements[this.cni];
        Utils.getFile(url).then(res => { if(res){
          let name = !(op%2) ? `Timbrado_${t}` : `Cancelado_${t}`, item = op < 2 ? CB : op < 4 ? CN : CO;
          if(item[name]) return;
              
          let xhr = new XMLHttpRequest();
          xhr.open("GET", url); xhr.responseType = "blob";
          xhr.onload = () => {
            let blob = xhr.response; blob.name = `${Utils.arrayLast(url.split('/'))}`;
            this.uploadFile(new Upload(<File> blob));
          };
          xhr.send();
          
        } })
      });
    }, */
    updateStatus: (status, uuid='') => {
      console.log(`Actualizando estatus a: ${status} en DB`);
      console.log(uuid ? `Actualizando uuid a : ${uuid}` : `No se actualiza el uuid en DB`)
      let {op, folio, cni} = this.search;
      console.log(op, folio);
      if(op < 2) return this.service.updateByField(uuid ? {status, uuid} : {status}, this.id);
      else if(op < 4){
        let o = { creditNotes: this.customerBill.creditNotes.map(({status: s, uuid: u, ...c}) => ({
          status: this.data.ncFolioR(folio) == c.folio ? status : s,
          uuid: !uuid || this.data.ncFolioR(folio) != c.folio ? u : uuid,
          ...c
        }) ) }
        return this.service.updateByField(o, this.id);
      }else if(op < 6){
         return this.incomeService.updateByField(uuid ? {status, uuid} : {status}, cni);
      }
    },
    uploadFile: (file: Upload, onDone=undefined) => {
      console.log('Subiendo archivo a bucket', file)
      return this.service.uploadFile(file, this.id, {
        cnI: this.search.op == 2 || this.search.op == 3 ? this.search.cni : -1,
        cns: this.customerBill.creditNotes,
        incId: this.search.op == 4 || this.search.op == 5 ? `${this.search.cni}` : '',
        incUuid: this.search.op == 4 || this.search.op == 5 ? `${this.search.uuid}` : '',
        onDone,
      })
    }
  }

  /* tempSearch(){
    return {
      self: this,
      counter: 0,
      interval: undefined,
      rfc: '', folio: '', status: 'key0',
      pdf: undefined, pdfCancel: undefined,
      xml: undefined, xmlCancel: undefined,
      msg: '',
      uuid: '',
      op: undefined,//0: timbrar, 1: cancelar, 2: ncTimbre, 3: ncCancel, 4: com, 5: comCancel
      cni: -1,
      get url(){ switch (this.op){
        case 0: return `https://interfaces.medicospro.com/facturacion/${this.rfc}/Cfdi/Factura_A_${this.folio}_Timbrado`;
        case 1: return `https://interfaces.medicospro.com/facturacion/${this.rfc}/cfdiCancelado/Factura_A_${this.folio}_Cancelado`;
        case 2: return `https://interfaces.medicospro.com/facturacion/${this.rfc}/notasCredito/Factura_N_${this.folio}_Timbrado`;
        case 3: return `https://interfaces.medicospro.com/facturacion/${this.rfc}/notasCredito/Factura_N_${this.folio}_Cancelado`;
        case 4: return `https://interfaces.medicospro.com/facturacion/${this.rfc}/CfdiPagos/Factura_Pa_${this.folio}_Timbrado`;
        case 5: return `https://interfaces.medicospro.com/facturacion/${this.rfc}/CfdiPagos/Factura_Pa_${this.folio}_Cancelado`;
      }; },
      start(n: number, op: number, {companyRfc: rfc, folio, status}, {cni=-1, onlyFiles=<any>false}={}){
        this.counter = n;
        this.op = op; this.rfc = rfc; this.folio = folio; this.status = status;
        this.cni = cni;
        if(n) this.interval = setInterval(this.cycle, 1000, this);
        else onlyFiles ? this.endFiles(onlyFiles) : this.end();
      },
      endFiles(arr){
        arr.map(t => {
          let url = `${Globals.PROXY_URL}${this.url}.${t}`, {op} = this;
          let CB = this.self.customerBill, CN = this.self.creditNotes[this.cni], CO = this.self.complements[this.cni];
          Utils.getFile(url).then(res => { if(res){
            let name = !(op%2) ? `Timbrado_${t}` : `Cancelado_${t}`, item = op < 2 ? CB : op < 4 ? CN : CO;
            if(item[name]) return;
                
            let xhr = new XMLHttpRequest();
            xhr.open("GET", url); xhr.responseType = "blob";
            xhr.onload = () => {
              let blob = xhr.response; blob.name = `${Utils.arrayLast(url.split('/'))}`;
              this.uploadFile(new Upload(<File> blob));
            };
            xhr.send();
            
          } })
        });
      },
      uploadFile(file: Upload) {
        this.self.service.uploadFile(file, this.self.id, {
          cnI: this.op == 2 || this.op == 3 ? this.cni : -1, cns: this.self.customerBill.creditNotes,
          comI: this.op == 4 || this.op == 5 ? this.cni : -1, coms: this.self.customerBill.complements,
        })
      }
    }
  } */

  ////////////////////////////////////////////////////////////////////////////////////////// Motivo Cancelación
  otherUuids: string[] = [];
  otherUuid: string = '';
  modalActionsCancel = new EventEmitter<string|MaterializeAction>();
  modalParamsCancel = [{dismissible: true}];
  openModalCancel() {
    this.modalActionsCancel.emit({ action: 'modal', params: ['open'] });
  }
  closeModalCancel() {
    this.modalActionsCancel.emit({ action: 'modal', params: ['close'] });
  }

  motivoCancelacion = '00';
  motivoCancelacionSelect = [
    {value: '00', name: 'Seleccione una opción'},
    {value: '01', name: 'Comprobante emitido con errores con relación'},
    {value: '02', name: 'Comprobante emitido con errores sin relación'},
    {value: '03', name: 'No se llevó a cabo la operación'},
    {value: '04', name: 'Operación nominativa relacionada en una factura global'},
  ];


  ///////// New Billing process
  //billingForm: HTMLFormElement;
  billingDevMode: boolean = false;
  billingApiHost: string = this.billingDevMode ? `http://localhost:8080/billing` : `https://appbackend.medicospro.com/billing`;
  async sendBillForStamping({ cancel = false, sync = false, ...opts }: { cnIndex?: number, incomeId?: string, cancel?: boolean, sync?: boolean } = {}){
    try{
      console.log(opts);
      let objBody = { v4Json: await this.createBillingJson('4.0', {...opts, sync}), billExtraData: await this.createBillingExtraData(opts) };
      let headers = { ['Content-Type']: 'application/x-www-form-urlencoded' };
      let body = `json=${encodeURIComponent(JSON.stringify(objBody))}&reqId=${Utils.String.random(8)}_${+new Date()}`;
      if(!sync && !confirm(`¿${ cancel ? 'Cancelar': 'Timbrar' } cfdi ${objBody.v4Json.Folio}?`)) return;
      let routeName = sync ? 'sync' : cancel ? 'cancel' : 'stamp';
      let response = await fetch(`${this.billingApiHost}/${routeName}V4`, {
        method: 'POST',
        headers,
        body,
      });
      let result = await response.json();
      if(!result.success) throw `Api returned error`;
      alert(`Éxito en la operación!`);
      console.log(result);
    }catch(error){
      console.log(error);
      if(error == 'FACTORAJE'){
        alert(`Timbrado no disponible.`);
        return;
      }
      if(error == 'SILENT') return;
      alert(`Error al solicitar ${cancel ? 'la cancelación' : 'el timbrado'}.`);
    }
  }
  async confirmUpdateIncomeFolio(incomeId: string): Promise<false | number> {
    let folios: Folios = await this.firestoreService.docWithId<Folios>(`${Globals.CATALOGS_SETTINGS}/folios`);
    let income: IncomeId = await this.firestoreService.docWithId<IncomeId>(`${Globals.INCOME_COLLECTION}/${incomeId}`);
    let newFolio = folios.income;
    let userFullName = this.authService.currentUser.fullName;
    let folioLog: FolioLog = {
      lastFolio: +income.folio,
      newFolio,
      datetime: Utils.stringDatetime(),
      lastUuid: income.uuid || '',
      userFullName,
    };
    let folioLogs = income.folioLogs || [];
    folioLogs.push(folioLog);
    if(!confirm(`Se cambiará el folio de ${income.folio} a ${newFolio}.`)) return false;
    await this.incomeService.updateByField({ folio: newFolio, folioLogs }, incomeId);
    await this.firestoreService.update(`${Globals.CATALOGS_SETTINGS}/folios`, { income: newFolio + 1 });
    return newFolio;
  }
  async openFile(bucketFile: BucketFile){
    let { access = 'public', path = '', url } = bucketFile;
    if(access == 'public'){
      window.open(url, '_blank');
    }else if(access == 'private'){
      //window.open(`${this.billingApiHost}/getBucketFile?projectId=${environment.cloudFirestore.projectId}&bucketPath=${path}`)
      try{
        let objBody = { projectId: environment.cloudFirestore.projectId, bucketPath: path };
        let headers = { ['Content-Type']: 'application/x-www-form-urlencoded' };
        let body = `json=${encodeURIComponent(JSON.stringify(objBody))}&reqId=${Utils.String.random(8)}_${+new Date()}`;
        let result = await fetch(`${this.billingApiHost}/getBucketFile`, { method: 'POST', headers, body });
        console.log(result);
        let blob = await result.blob();
        let extension = bucketFile.name.replace(/.*\./, '');
        switch(extension){
          case 'pdf': blob = blob.slice(0, blob.size, 'application/pdf'); break;
          case 'xml': blob = blob.slice(0, blob.size, 'application/xml'); break;
          case 'png': blob = blob.slice(0, blob.size, 'image/png'); break;
        }
        console.log(blob);
        let fileName = bucketFile.name.substring(bucketFile.name.lastIndexOf('/') + 1);
        if(confirm(`¿Descargar ${fileName}?`)){
          let a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = `${fileName}`;
          a.click();
        }
        return window.open(URL.createObjectURL(blob), '_blank');
      }catch(error){
        console.log(error);
        return '';
      }
    }
  }
  async createBillingJson<Version extends '4.0'>(version: Version, { cnIndex = -1, incomeId = null, sync = false }: { cnIndex?: number, incomeId?: string, sync?: boolean }): Promise<BillingJsonVersion4> {
    console.log(this.customerBill);
    console.log(this.creditNotes);
    console.log(this.incomes);

    const RET_ISR = 0, RET_IVA = 1;

    const isCreditNote = cnIndex != -1;
    const isPayment = incomeId != null;

    let creditNote: CreditNote = this.creditNotes[cnIndex];
    if(!creditNote){
      if(isCreditNote) Utils.throwAndAlert(`No creditNote of index ${cnIndex}.`, 'No se encontró la nota de crédito.');
      creditNote = { total: 0, subtotal: 0 } as CreditNote;
    }
    let income: IncomeTable = this.incomes.find(income => income.id == incomeId);
    if(!income){
      if(isPayment) Utils.throwAndAlert(`No income of id ${incomeId}.`, 'No se encontró el ingreso.');
      income = { amount: 0 } as IncomeTable;
    }
    if(isPayment){
      if(!sync && income.uuid && income.status != 'key0'){
        let newFolio = await this.confirmUpdateIncomeFolio(incomeId);
        if(!newFolio) throw 'SILENT';
        income.folio = `${newFolio}`;
      }
    }
    console.log(isPayment, income);

    const chooseByType = <T>(values: { bill: T, cn: T, inc: T }): T => {
      if(isCreditNote) return values.cn;
      if(isPayment) return values.inc;
      return values.bill;
    };

    const ivaPercentage = this.settings.defaults.iva/100;
    const isrRetPercentage = this.settings.defaults.isrRetention/100;
    const ivaRetPercentage = this.settings.defaults.ivaRetention/100;
    const billPayForm = this.data.payFormSelect[this.customerBill.cfdi.payForm].index;
    const billCurrency = this.data.currencySelect[this.customerBill.cfdi.currency].code;
    if(version == '4.0'){
      let Traslados: BillingJsonVersion4['Impuestos']['Traslados'] = [
        { Base: '0.00', Importe: '0.00', Impuesto: '002', TasaOCuota: ivaPercentage.toFixed(6), TipoFactor: 'Tasa' },
      ];
      let Retenciones: BillingJsonVersion4['Impuestos']['Retenciones'] = [
        { Importe: '0.00', Impuesto: '001' },
        { Importe: '0.00', Impuesto: '002' },
      ];
      let billingJson: BillingJsonVersion4 = {
        Version: version,
        FormaPago: chooseByType({ bill: billPayForm, cn: billPayForm, inc: income.payMethod }),
        Serie: chooseByType<BillingJsonVersion4['Serie']>({ bill: 'A', cn: 'CN', inc: 'P' }),
        Folio: `${chooseByType({ bill: `${this.customerBill.folio}`, cn: creditNote.folio, inc: income.folio })}`,
        Fecha: '', // `${this.customerBill.date}T00:00:00`,
        MetodoPago: this.data.payMethodSelect[this.customerBill.cfdi.payMethod].code,
        Sello: '',
        NoCertificado: '',
        Certificado: '',
        CondicionesDePago: this.data.payConditionsSelect[this.customerBill.cfdi.payConditions].name,
        SubTotal: chooseByType<number>({ bill: this.customerBill.totals.amountNoDisc, cn: creditNote.subtotal, inc: 0 }).toFixed(2),
        Descuento: (this.customerBill.totals.amountNoDisc - (this.customerBill.totals.subtotal + this.customerBill.totals.retIsr + this.customerBill.totals.retIva)).toFixed(2),
        Moneda: chooseByType({ bill: billCurrency, cn: billCurrency, inc: income.currency }),
        TipoCambio: this.customerBill.cfdi.change.toFixed(this.customerBill.cfdi.change%1 != 0 ? 2 : 0),
        Total: chooseByType<number>({ bill: this.customerBill.totals.total, cn: creditNote.total, inc: income.amount }).toFixed(2),
        TipoDeComprobante: chooseByType<BillingJsonVersion4['TipoDeComprobante']>({ bill: 'I', cn: 'E', inc: 'P' }),
        Exportacion: '01',
        LugarExpedicion: this.customerBill.companyZipCode,
        Emisor: {
          Rfc: this.customerBill.companyRfc,
          Nombre: this.customerBill.companyFiscalData,
          RegimenFiscal: this.customerBill.companyFiscalRegimen,
        },
        Receptor: {
          Rfc: this.customerBill.fiscalDataObj.rfc,
          Nombre: this.customerBill.fiscalDataObj.businessName,
          DomicilioFiscalReceptor: this.customerBill.fiscalDataObj.rfc == 'XAXX010101000' ? this.customerBill.companyZipCode : this.customerBill.fiscalDataObj.postCode,
          RegimenFiscalReceptor: this.companyData.fiscalRegimenSelect[this.customerBill.fiscalDataObj.fiscalRegimen || 'key0'].code,
          UsoCFDI: this.data.cfdiUsageSelect[this.customerBill.fiscalDataObj.cfdi.cfdiUsage].code,
        },
        Conceptos: [
          ...this.customerBill.prForBills.map((prForBill, prIndex) => {
            Traslados[0].Base = (+Traslados[0].Base + prForBill.amount).toFixed(2);
            Traslados[0].Importe = (+Traslados[0].Importe + prForBill.iva).toFixed(2);
            let ConceptRetenciones: BillingJsonVersion4['Conceptos'][number]['Impuestos']['Retenciones'] = [];
            if(prForBill.retIsr){
              Retenciones[RET_ISR].Importe = (+Retenciones[RET_ISR].Importe + prForBill.retIsr).toFixed(2);
              ConceptRetenciones.push({ Base: prForBill.amount.toFixed(2), Importe: prForBill.retIsr.toFixed(2), Impuesto: '001', TasaOCuota: isrRetPercentage.toFixed(6), TipoFactor: 'Tasa' });
            }
            if(prForBill.retIva){
              Retenciones[RET_IVA].Importe = (+Retenciones[RET_IVA].Importe + prForBill.retIva).toFixed(2);
              ConceptRetenciones.push({ Base: prForBill.amount.toFixed(2), Importe: prForBill.retIva.toFixed(2), Impuesto: '002', TasaOCuota: ivaRetPercentage.toFixed(6), TipoFactor: 'Tasa' });
            }
            return <BillingJsonVersion4['Conceptos'][number]>{
              ClaveProdServ: prForBill.productSatKey,
              NoIdentificacion: Utils.initials(prForBill.product),
              Cantidad: prForBill.quantity.toFixed(2),
              ClaveUnidad: prForBill.unitSatKey,
              Unidad: this.prVntaData.unitSatKeyObjects[prForBill.unitSatKey].description,
              Descripcion: prForBill.product,
              ValorUnitario: prForBill.pricePerUnit.toFixed(4),
              Importe: prForBill.amountNoDisc.toFixed(2),
              Descuento: (prForBill.amountNoDisc - prForBill.amount).toFixed(2),
              ObjetoImp: '02',
              Impuestos: {
                Traslados: [{
                  Base: prForBill.amount.toFixed(2),
                  Importe: prForBill.iva.toFixed(2),
                  Impuesto: '002',
                  TasaOCuota: ivaPercentage.toFixed(6),
                  TipoFactor: 'Tasa',
                }],
                Retenciones: ConceptRetenciones,
              },
            };
          }),
        ],
        Impuestos: {
          TotalImpuestosTrasladados: this.customerBill.totals.iva.toFixed(2),
          TotalImpuestosRetenidos: (this.customerBill.totals.retIsr + this.customerBill.totals.retIva).toFixed(2),
          Retenciones: Retenciones.filter(Retencion => +Retencion.Importe),
          Traslados,
        },
      };
      return billingJson as never;
    }
    return null;
  }
  async createBillingExtraData({ cnIndex = -1, incomeId = null }: { cnIndex?: number, incomeId?: string }){

    const isCreditNote = cnIndex != -1;
    const isPayment = incomeId != null;

    let creditNote: CreditNote = this.creditNotes[cnIndex];
    if(!creditNote){
      if(isCreditNote) Utils.throwAndAlert(`No creditNote of index ${cnIndex}.`, 'No se encontró la nota de crédito.');
      creditNote = {} as CreditNote;
    }
    let income: IncomeTable = this.incomes.find(income => income.id == incomeId);
    if(!income){
      if(isPayment) Utils.throwAndAlert(`No income of id ${incomeId}.`, 'No se encontró el ingreso.');
      income = {} as IncomeTable;
    }

    const chooseByType = <T>(values: { bill: T, cn: T, inc: T }): T => {
      if(isCreditNote) return values.cn;
      if(isPayment) return values.inc;
      return values.bill;
    };

    let paymentBills: {
			billId: string,
			uuid: CustomerBill['uuid'],
			serie: BillingJsonVersion4['Serie'],
			folio: number,
			currency: BillingJsonVersion4['Moneda'],
      bias: number,
			change: number,
			amount: number,
			remainingBalance: number,
      extraBias: number,
      extraAmount: number,
		}[] = [];
    if(isPayment){
      if(!income.bills) throw `No bills on payment.`;
      //if(this.customerBill.extraFiscalDataId) throw `FACTORAJE`;
      for(let { customerBillId: billId, amount, extraAmount = 0 } of income.bills){
        let billDoc: CustomerBill = await this.firestoreService.docWithId<CustomerBill>(`${Globals.CUSTOMER_BILL_COLLECTION}/${billId}`);
        if(!billDoc.uuid) Utils.throwAndAlert('Bill is not stamped.', `La factura ${billDoc.folio} no está timbrada.`);
        if(!billDoc.stampedIncomes) billDoc.stampedIncomes = [ { incomeId: '', bias: 0, amount: 0, extraBias: 0, extraAmount: 0 } ];
        let stampedIncome = billDoc.stampedIncomes.find(si => si.incomeId == incomeId);
        //let bias = stampedIncome && stampedIncome.bias || ([...billDoc.stampedIncomes].sort((a, b) => a.bias < b.bias ? 1 : -1)[0].bias + 1);

        let bias = stampedIncome && stampedIncome.bias || (billDoc.stampedIncomes.reduce((acc, cur) => Math.max(acc, cur.bias || 0, cur.extraBias || 0), 0) + 1);
        let extraBias = extraAmount ? ( stampedIncome && stampedIncome.extraBias || (bias + 1) ) : bias;
        paymentBills.push({
          billId,
          uuid: billDoc.uuid,
          serie: 'A',
          folio: billDoc.folio,
          currency: this.data.currencySelect[billDoc.cfdi.currency].code,
          bias,
          change: billDoc.cfdi.change,
          amount,
          remainingBalance: billDoc.totals.total,
          extraBias,
          extraAmount,
        });
      }
    }

    return {
      projectId: environment.cloudFirestore.projectId,

      companyFiles: this.customerBill.companyFiles,
      companyImgUrl: this.customerBill.companyImgUrl,
      companyName: this.customerBill.companyName,
      companySatPrivateKey: this.customerBill.companySatPrivateKey,

      customerName: this.customerName,
      customerRfc: this.customerBill.fiscalDataObj.rfc,
      customerFiscalData: this.customerBill.fiscalDataObj.businessName,
      customerPostalCode: this.customerBill.fiscalDataObj.postCode || '',
      customerFiscalRegimen: this.companyData.fiscalRegimenSelect[this.customerBill.fiscalDataObj.fiscalRegimen || 'key0'].full,
      
      productionOrder: this.customerBill.productionOrder,
      
      billId: isPayment ? incomeId : this.id,
      folio: this.customerBill.folio,
      date: this.customerBill.date,
      receptionDate: this.customerBill.receptionDate,
      payDate: this.customerBill.payDate,
      prForBills: this.prForBills.map(pr => ({...pr, discountAmount: +((+(pr.pricePerUnit*pr.quantity).toFixed(2))*(pr.discountPct/100)).toFixed(2)})),
      creditNotes: this.creditNotes,
      incomeds: this.incomesTable.rows1.map(row => ({folio: row[0], uuid: row[7], amount: row[4], extraAmount: row[5]})),
      totals: this.customerBill.totals,
      cfdi: this.customerBill.cfdi,

      associatedRelationType: isCreditNote ? this.data.cnRelations[creditNote.cfdiRelation || 'key0'].index : this.customerBill.associatedRelationType,
      associatedBillFolio: this.customerBill.associatedBillFolio,
      associatedBillDate: this.customerBill.associatedBillDate,
      associatedBillAmount: this.customerBill.associatedBillAmount,
      associatedBillUuid: chooseByType({ bill: this.customerBill.associatedBillUuid, cn: this.customerBill.uuid, inc: income.uuid || '' }),
      
      motivoCancelacion: this.motivoCancelacion,
      otherUuid: this.otherUuid || '',


      paymentBills,
      factorajeBusinessName: this.customerBill.extraFiscalDataId && this.customerBill.extraFiscalObj.businessName || '',
      factorajeRfc: this.customerBill.extraFiscalDataId && this.customerBill.extraFiscalObj.rfc || '',
      factorajePostCode: this.customerBill.extraFiscalDataId && this.customerBill.extraFiscalObj.postCode || '',
    };
  }

}

//both rfc and razon social
